import Vue from "vue";
import router from "./router";
import utils from "./utils";
import "./server";
import "./filter";
import "element-ui/lib/theme-chalk/index.css";
import "animate.css/animate.css";
import VueLazyload from "vue-lazyload";

import App from "./App.vue";
import CollectUserInfoDialog from "./components/CollectUserInfoDialog.vue";
import {
  Dialog,
  Input,
  Menu,
  MenuItem,
  Option,
  Scrollbar,
  Table,
  TableColumn,
  TabPane,
  Tabs,
  Main,
  Container,
  Aside,
  MenuItemGroup,
  MessageBox,
  Message,
  Form,
  FormItem,
  Checkbox,
  Button,
  Steps,
  Step,
  Select,
  Upload,
  Loading
} from "element-ui";

Vue.config.productionTip = false
Vue.use(VueLazyload, {
  lazyComponent: true
})

Vue.component(CollectUserInfoDialog.name,CollectUserInfoDialog)
Vue.component(Scrollbar.name, Scrollbar)
Vue.component(Table.name, Table)
Vue.component(TableColumn.name, TableColumn)
Vue.component(Input.name, Input)
Vue.component(Dialog.name, Dialog)
Vue.component(Option.name, Option)
Vue.component(Menu.name, Menu)
Vue.component(MenuItem.name, MenuItem)
Vue.component(MenuItemGroup.name, MenuItemGroup)
Vue.component(Tabs.name, Tabs)
Vue.component(TabPane.name, TabPane)
Vue.component(Main.name, Main)
Vue.component(Container.name, Container)
Vue.component(Aside.name, Aside)
Vue.component(MessageBox.name, MessageBox)
Vue.component(Message.name, Message)
Vue.component(Form.name, Form)
Vue.component(FormItem.name, FormItem)
Vue.component(Checkbox.name, Checkbox)
Vue.component(Button.name, Button)
Vue.component(Steps.name, Steps)
Vue.component(Step.name, Step)
Vue.component(Select.name, Select)
Vue.component(Upload.name, Upload)
Vue.use(Loading.directive);

window.$app = new Vue({
  router,
  methods: {
    ...utils
  },
  render: h => h(App),
  components: {
    // 'CollectUserInfoDialog': (CollectUserInfoDialog,{props: ['show']}),
    // 'videoDialog': (videoDialog,{props: ['show','dialogVideoPoster','dialogVideoUrl']})
  },
  watch: {
    '$route' (to, from) {
      const toDepth = to.path.split('/').length
      const fromDepth = from.path.split('/').length
      this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'
    }
  },
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js